
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

import CommonTitle from './components/commonTitle.vue';

@Component({
  components: { CommonTitle }
})
export default class ProductDoc extends Vue {
  moreLinks: any[] = [
    'https://open.mingyuanyun.com/docs/platform/jian-mo-ping-tai/lian-dong-gui-ze.html',
    'https://open.mingyuanyun.com/docs/mip/api-center/introduction/chan-pin-jian-jie.html'
  ];

  @Getter docHomelist: any;
  @Action('getHomelist') getHomelist: Function;

  @Getter productDocById: any;
  @Action("getDocProductById") getDocProductById: Function;
  mounted() {
    this.getDocProductById({ OnlyEnabled: true, OnlyHomePage: true, LimitNum: 6 }).then(() => {
      for (const item of this.productDocById.infos) {
        if (item.ProductDocCatalog) {
          this.getHomelist({
            FolderID: item.ProductDocCatalog,
            Top: 5
          }).then(()=>{
            Vue.set(item, 'children', this.docHomelist.infos);
          });
        }
      }
    });
  }
  handleClick(parent: any, param: any) {
    if (!!param.Url) {
      window.open(param.Url, '_blank');
    } else if (!!param.ID && !!parent.ProductDocCatalog) {
      const resolved = this.$router.resolve({
        path: 'documents/docreview',
        query: {
          id: parent.ProductDocCatalog,
          ver: parent.FolderID,
          docid: param.ID,
          title: parent.Title
        }
      });
      window.open(resolved.href, '_blank')
    }
  }
}
